export const MS_IN_MINUTE = 1000 * 60
export const MS_IN_HOUR = MS_IN_MINUTE * 60
export const MS_IN_DAY = MS_IN_HOUR * 24

// Added new constants for additional time durations
export const MS_IN_5_MINUTES = MS_IN_MINUTE * 5
export const MS_IN_10_MINUTES = MS_IN_MINUTE * 10
export const MS_IN_15_MINUTES = MS_IN_MINUTE * 15
